module.exports = "pegasus/assets/tech/safari/105.png";